import { AxiosPromise } from "axios";
import { ApiRequestAdapter } from "../../../common/api/ApiRequestAdapter";
import { apiService } from "../../../common/api/apiService";
import { HttpMethod } from "../../../common/api/http";
import { EntityIdObject, EntityObject } from "../../../common/types";
import {
  CommissionAdvance,
  CreateCommissionAdvance,
  CreateCommissionAdvanceCancellation,
  UpdateCommissionAdvance,
} from "./types";

const GET_COMMISSION_ADVANCE = ApiRequestAdapter.create("/contracts/{0}/commission-advances", HttpMethod.GET);
const CREATE_COMMISSION_ADVANCE = ApiRequestAdapter.create("/contracts/{0}/commission-advances", HttpMethod.POST);
const UPDATE_COMMISSION_ADVANCE = ApiRequestAdapter.create("/contracts/{0}/commission-advances", HttpMethod.PUT);
const CREATE_COMMISSION_ADVANCE_CANCELLATION = ApiRequestAdapter.create(
  "/contracts/{0}/commission-advances/cancellations",
  HttpMethod.PUT,
);
const DELETE_COMMISSION_ADVANCE_CANCELLATION = ApiRequestAdapter.create(
  "/contracts/{0}/commission-advances/cancellations",
  HttpMethod.DELETE,
);

export const commissionAdvanceApi = {
  getCommissionAdvance: (request: EntityIdObject): AxiosPromise<CommissionAdvance> => {
    return apiService.get(GET_COMMISSION_ADVANCE.getParametrizedUrl(request.id));
  },
  createCommissionAdvance: (request: EntityObject<CreateCommissionAdvance>): AxiosPromise<CommissionAdvance> => {
    return apiService.post(CREATE_COMMISSION_ADVANCE.getParametrizedUrl(request.id), request.object);
  },
  updateCommissionAdvance: (request: EntityObject<UpdateCommissionAdvance>): AxiosPromise<CommissionAdvance> => {
    return apiService.put(UPDATE_COMMISSION_ADVANCE.getParametrizedUrl(request.id), request.object);
  },
  createCommissionAdvanceCancellation: (
    request: EntityObject<CreateCommissionAdvanceCancellation>,
  ): AxiosPromise<CommissionAdvance> => {
    return apiService.put(CREATE_COMMISSION_ADVANCE_CANCELLATION.getParametrizedUrl(request.id), request.object);
  },
  deleteCommissionAdvanceCancellation: (request: EntityIdObject): AxiosPromise => {
    return apiService.delete(DELETE_COMMISSION_ADVANCE_CANCELLATION.getParametrizedUrl(request.id));
  },
};
